<template>
  <div class="main-wrapper">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary2 fixed-top" id="sideNav">
      <a class="navbar-brand js-scroll-trigger" href="#about">
        <span class="d-block d-lg-none">Power-Devel</span>
        <span class="d-none d-lg-block">
          <img
            class="img-fluid img-profile rounded-circle mx-auto mb-2"
            src="./assets/profile.jpg"
            alt
          >
        </span>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#about">¿Quienes Somos?</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#experience">Experiencia</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#education">Conocimientos</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#skills">Soluciones</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#products">Nuestros Productos</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#interests">Nuestros Clientes</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#contacto">Contacto</a>
          </li>
          <li class="list-inline-item">
            <a href="https://www.facebook.com/PowerDevel/" target="_blank">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container-fluid p-0">
      <section class="resume-section p-3 p-lg-5 d-flex d-column" id="about">
        <div class="my-auto">
          <section class="module parallax parallax-titulo">
            <div class="container text-center" style="padding-top:90px;">
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/logo-blanco.png"
                alt="Power-Devel"
                width="500px"
                height="auto"
              >
            </div>
          </section>
          <p/>
          <div class="row">
            <div class="col-sm-8">
              <br>
              <br>
              <h5>Somos una empresa especializada en desarrollo de software y administración de bases de datos. prestamos servicios de asesoría, desarrollo y consultoría.</h5>
              <hr>
              <div
                class="text-justify"
              >Power-Devel ofrece servicios de soporte, mantenimiento y reingeniería de bases de datos relacionales, orientadas a documentos u orientadas a grafos.</div>
              <hr>
              <div
                class="text-justify"
              >Nos encargamos de desarrollar software para entornos empresariales a la medida de sus necesidades.</div>
              <hr>
              <div
                class="text-justify"
              >Nuestro portafolio se orienta a cualquier compañía que requiera de un proveedor especializado y de confianza para abordar proyectos que requieran de un servicio profesional, eficiente, con experiencia y conocimiento en entornos tecnológicos de bases de datos y desarrollos de software.</div>
              <hr>
              <div
                class="text-justify"
              >El desarrollo de aplicaciones de software en Power-Devel ha alcanzado el más alto nivel de madurez, garantizando que nuestros servicios de ingeniería y mantenimiento de software sean del nivel esperado por su empresa.</div>
              <hr>
              <div
                class="text-justify"
              >En Power-Devel estamos a la vanguardia tecnológica y en constante capacitación para brindar a nuestros clientes soluciones modernas que realmente les puedan servir a largo plazo.</div>
            </div>
            <div class="col-sm-4">
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/software1.png"
                alt="Power-Devel"
              >
            </div>
          </div>
        </div>
      </section>
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="experience">
        <div class="my-auto">
          <section class="module parallax parallax-1">
            <div class="container">
              <h1>Experiencia</h1>
            </div>
          </section>
          <p/>
          <div class="row">
            <div class="col-sm-8">
              <br>
              <h5>Contamos con personal de mas de 15 años de experiencia en el desarrollo de software.</h5>
              <h6>Dentro de los desarrollos mas importantes de los que fuimos parte sobresalen los siguientes:</h6>
              <br>Reingeniería y Desarrollo de un Sistema de control de Expedientes de Comercio Exterior administrando mas de 10 millones de archivos.
              <hr>Desarrollo de un Sistema Integral de Recursos Humanos para mas de 10 mil empleados, administrando Nómina, Capacitación, Reclutamiento, Seguridad Social, Timbrado Fiscal, etc.
              <hr>Desarrollo de un sistema de Registro Civil con la administración de mas de 5 millones de actas de nacimiento, matrimonio, defunción, etc.
              <hr>Desarrollo de un Sistema Notarial para el registro de Índices de mas de 50 notarias y 5 mil libros de actos notariales.
              <hr>
              <div
                class="text-justify"
              >Desarrollo de Sistema para control de operaciones diarias para empresas gaseras, con mas de 300 puntos de venta, y una aplicación móvil para iOS y Android que consulta reportes ejecutivos del sistema.</div>
              <hr>Desarrollo de Puntos de Venta para Pequeñas y Medianas Empresas.
            </div>
            <div class="col-sm-4">
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/software2.png"
                alt="Power-Devel"
              >
            </div>
          </div>
        </div>
      </section>
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="education">
        <div class="my-auto col-sm-12">
          <section class="module parallax parallax-2">
            <div class="container">
              <h1>Conocimientos</h1>
            </div>
          </section>
          <br>
          <div class="row">
            <div class="col-sm-8">
              <h5>¿Como Trabajamos?</h5>
              <div
                class="text-justify"
              >Utilizamos metodologías agiles " Scrum y Kanban " con entrega de avance periódico, permitiendo un acercamiento y revisión directo con el cliente lo cual generara un desarrollo perfectamente a la medida de sus necesidades.</div>
              <hr>
              <div class="text-justify">
                Con el fin de innovar en las tecnologías de vanguardia actualmente realizamos desarrollos en micro servicios, creando el frontend y backend de nuestras aplicaciones por separado,
                de esta forma tu aplicación puede ser escalada conforme a tu demanda de servicio sin necesidad de nuevo desarrollo, esta tecnología es la que utilizan actualmente empresas como Netflix, Facebook, Google, Amazon entre otros.
              </div>
              <hr>
              <div
                class="text-justify"
              >Para almacenar la información utilizamos las bases de datos adecuadas a lo que realmente requiere el cliente ya sea base de datos relacionales o base de datos orientadas a documentos, dependiendo de el tipo de información y volumen que se maneje.</div>
              <hr>
              <h5>Nuestro Personal cuenta con las Siguientes Certificaciones:</h5>
              <ul>
                <li class="text-justify">Scrum Master</li>
                <li class="text-justify">Zend Certified Engineer PHP</li>
                <li class="text-justify">Python Developer</li>
                <li class="text-justify">C# Developer</li>
                <li class="text-justify">Android Developer Sr</li>
                <li class="text-justify">Oracle Certified Professional, Java Programmer</li>
                <li class="text-justify">Swift Developer</li>
                <li class="text-justify">ISTQB Certified Tester (Foundation Level)</li>
                <li class="text-justify">Linux Professional Institute (LPIC-1)</li>
                <li class="text-justify">Ruby on Rails Developer</li>
              </ul>
            </div>
            <div class="col-sm-4">
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/software3.png"
                alt="Power-Devel"
              >
            </div>
          </div>
        </div>
      </section>
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="skills">
        <div class="my-auto">
          <section class="module parallax parallax-3">
            <div class="container">
              <h1>Soluciones</h1>
            </div>
          </section>
          <div class="row">
            <br>
            <div class="col-sm-8">
              <br>
              <h5>¿En que te podemos ayudar?</h5>
              <br>
              <div
                class="text-justify"
              >Ya cuentas con un sistema, es viejo y obsoleto, no cumple con tus necesidades, esta lento, tiene fallas recurrentes nosotros te lo rehacemos con tecnologías de vanguardia.</div>
              <hr>
              <div
                class="text-justify"
              >El manejo de tu información te lleva mucho tiempo, su proceso es tardado nosotros sistematizamos tus procesos.</div>
              <hr>
              <div
                class="text-justify"
              >Tu empresa requiere un portal web para ventas por internet, nosotros te lo hacemos de acuerdo a tus necesidades.</div>
              <hr>
              <div
                class="text-justify"
              >Ya cuentas con un sistema que actualmente te funciona, pero requieres nuevos módulos como nuevos reportes de consulta, etc. Nosotros te lo actualizamos.</div>
              <hr>
              <div
                class="text-justify"
              >Requieres una aplicación móvil que interactúe con tu sistema nosotros te la desarrollamos tanto para iOS como para Android.</div>
              <hr>
              <div
                class="text-justify"
              >Requieres un sistema completamente nuevo, que requiera distintas interfaces como aplicaciones de escritorio, aplicaciones móviles o aplicaciones web nosotros te diseñamos y desarrollamos tu sistema integral.</div>
              <hr>
              <div
                class="text-justify"
              >Tienes la idea de un producto de software el cual puedes comercializar nosotros te lo desarrollamos.</div>
              <hr>
            </div>
            <div class="col-sm-4">
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/software4.png"
                alt="Power-Devel"
              >
            </div>
          </div>
        </div>
      </section>
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="products">
        <div class="my-auto">
          <section class="module parallax parallax-6">
            <div class="container">
              <h1>Nuestros Productos</h1>
            </div>
          </section>
          <div class="row">
            <div class="col-sm-8">
              <br>
              <h3>Sistema de PreVenta</h3>
              <div class="text-justify">
                Es un sistema SaaS que permite darles seguimiento a las posibles ventas de tu negocio, si tu cliente realizó una cotización,
                y no le das el seguimiento correcto al interés de su compra son posibles ventas que se van.
                <hr>El sistema te permite registrar esas llamadas o visitas de los clientes y cada seguimiento ya sea que el llame o tu le llames.
                Se podrá actualizar el estatus de la notificación especificando si sigue abierta o ya se concreto la venta.
                <hr>En el sistema se registra el día en que quieres volverle a llamar al cliente y te aparecerán esas notificaciones en ese día
                así te recordara que debes ponerte en contacto y podrás registrar ese seguimiento a la notificación.
                <hr>En el sistema podrás registrar todas las cotizaciones que se soliciten ya sea presencial o por teléfono.
                <hr>El sistema es multi-usuario y multi-sucursal por lo que si cuentas con varias sucursales podrás tener el control de todas.
                <hr>Los usuarios cuentan con un nivel de permisos que no les permite editar ni borrar notificaciones previamente realizadas solo el administrador podrá eliminarlas.
                <hr>Como usuario ejecutivo podrás generar reportes por periodo de fecha y estatus de las notificaciones de cada una de las sucursales.
                <hr>
                <h5>¿Cuanto me costara?</h5>El sistema se encuentra alojado en nuestros servidores por lo que no requieres realizar ninguna inversión ni instalación en los equipos
                es un sistema web al cual podrás acceder por un navegador de internet desde cualquier computadora o dispositivo móvil.
                <hr>Para el uso del sistema se paga una renta mensual a muy bajo costo, nuestros precios son muy accesibles y manejamos paquetes por numero de sucursales.
                <hr>Damos un periodo de pruebas de 15 días sin ningún compromiso, para que utilices el sistema y veas si realmente es lo que necesitas.
                <hr>
                <h6>Te interesa o tienes dudas no dudes en contactarnos.</h6>
              </div>
              <hr>
            </div>
            <div class="col-sm-4">
              <br>
              <br>
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/software5.png"
                alt="Power-Devel"
              >
            </div>
          </div>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="interests">
        <div class="my-auto">
          <section class="module parallax parallax-4">
            <div class="container">
              <h1>Nuestros Clientes</h1>
            </div>
          </section>
          <div class="row">
            <div class="col-sm-8">
              <br>
              <h5>Actualmente estamos involucrados en los siguientes proyectos:</h5>
              <ul>
                <li
                  class="text-justify"
                >Actualizamos y damos soporte a la plataforma E-Connect Vucem la cual cuenta con mas de 200 clientes.</li>
                <div class="text-center">
                  <img
                    class="img-fluid img-profile mx-auto mb-2"
                    src="./assets/vucem.png"
                    alt="Vucem"
                    width="150px"
                  >
                </div>
                <hr>
                <li
                  class="text-justify"
                >Actualizamos y damos soporte a la plataforma E-Connect DataStage el cual administra mas de 10 millones de archivos.</li>
                <div class="text-center">
                  <img
                    class="img-fluid img-profile mx-auto mb-2"
                    src="./assets/econnect.png"
                    alt="DataStage"
                    width="150px"
                  >
                </div>
                <hr>
                <li
                  class="text-justify"
                >Actualizamos y damos soporte a la plataforma Solucion-A31 la cual permite validar los créditos fiscales derivados de importaciones temporales.</li>
                <div class="text-center">
                  <img
                    class="img-fluid img-profile mx-auto mb-2"
                    src="./assets/soluciona.png"
                    alt="solucionA31"
                    width="150px"
                  >
                </div>
                <hr>
                <li
                  class="text-justify"
                >Desarrollamos una nueva plataforma Pro-Control la cual permitirá integrar y modernizar las plataformas anteriormente mencionadas ya en producción, además de nuevos módulos como Administrar trafico de mercancías y costeos, implementando micro servicios y base de datos orientadas a documentos, para poder soportar un mayor numero de usuarios debido a su gran demanda.</li>
                <div class="text-center">
                  <img
                    class="img-fluid img-profile mx-auto mb-2"
                    src="./assets/procontrol.png"
                    alt="procontrol"
                    width="150px"
                  >
                </div>
                <hr>
                <li
                  class="text-justify"
                >Actualizamos y damos soporte al sistema de control administrativo de gaseras Upper-Level, el cual cuenta con mas de 300 puntos de venta.</li>
                <div class="text-center">
                  <img
                    class="img-fluid img-profile mx-auto mb-2"
                    src="./assets/upper-level.png"
                    alt="procontrol"
                    width="150px"
                  >
                </div>
              </ul>
            </div>
            <div class="col-sm-4">
              <br>
              <br>
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/software6.png"
                alt="Power-Devel"
              >
            </div>
          </div>
        </div>
      </section>
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="contacto">
        <div class="my-auto">
          <section class="module parallax parallax-5">
            <div class="container">
              <h1>Contacto</h1>
            </div>
          </section>
          <div class="row">
            <br>
            <div class="col-sm-8">
              <br>
              <h3>Como Contactarnos</h3>
              <ul>
                <li class="text-justify">
                  <h6>Domicilio</h6>
                  <a
                    href="https://www.google.com.mx/maps/place/Power-Devel/@22.7711011,-102.5531831,17.01z/data=!4m5!3m4!1s0x86824f17d29fac83:0x111525d0d287397f!8m2!3d22.7710776!4d-102.5509461"
                  >Acceso a Solidaridad #108, Frac. Villa Antigua, Zacatecas, Zacatecas.</a>
                </li>
                <li class="text-justify">
                  <h6>Teléfono</h6>01 492 156 95 85
                </li>
                <li class="text-justify">
                  <h6>Email</h6>
                  <a href="mailto:contacto@power-devel.com">contacto@power-devel.com</a>
                </li>
              </ul>
              <h3>Nuestro Staff</h3>
              <ul>
                <li class="text-justify">
                  <h6>General Manager</h6>Porfirio Jara
                </li>
                <li class="text-justify">
                  <h6>Buisnes Analyst Manager</h6>Gustavo Montoya
                </li>
                <li class="text-justify">
                  <h6>Software Develomment Manager</h6>Alfonso Quintero
                </li>
                <li class="text-justify">
                  <h6>Project Tester Manager</h6>Enrique Miramontes
                </li>
              </ul>
            </div>
            <div class="col-sm-4">
              <br>
              <img
                class="img-fluid img-profile mx-auto mb-2"
                src="./assets/software6.jpg"
                alt="Power-Devel"
              >
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'Software Solutions',
      name: 'Power-Devel',
      surname: 'Software Solutions'
    }
  },
  mounted () {
    const $ = this.jquery
    this.$nextTick(() => {
      // our custom jQuery code goes here
      $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
        if (
          location.pathname.replace(/^\//, '') ===
            this.pathname.replace(/^\//, '') &&
          location.hostname === this.hostname
        ) {
          var target = $(this.hash)
          target = target.length
            ? target
            : $('[name=' + this.hash.slice(1) + ']')
          if (target.length) {
            $('html, body').animate(
              {
                scrollTop: target.offset().top
              },
              1000,
              'easeInOutExpo'
            )
            return false
          }
        }
      })
      // Closes responsive menu when a scroll trigger link is clicked
      $('.js-scroll-trigger').click(function () {
        $('.navbar-collapse').collapse('hide')
      })

      // Activate scrollspy to add active class to navbar items on scroll
      $('body').scrollspy({
        target: '#sideNav'
      })
    })
  }
}
</script>

<style>
body {
  font-family: 'Open Sans', serif;
  padding-top: 54px;
  color: #868e96;
}
* {
  box-sizing: border-box;
  font-family: Avenir;
}
.bg-primary2 {
    background-color:#0F375B !important;
}
.module {
  clear: both;
}

.container {
  /*   max-width: 960px; */
  margin: 10px auto;
}

section.module:last-child {
  margin-bottom: 0;
}
section.module h2 {
  margin-bottom: 40px;
  font-size: 30px;
}
section.module p {
  margin-bottom: 40px;
  font-size: 16px;
  font-weight: 300;
}
section.module p:last-child {
  margin-bottom: 0;
}
section.module.content {
  padding: 40px;
}
section.module.parallax {
  height: 300px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

section.module.parallax h1 {
  color: rgba(255, 255, 255, 0.8);
  font-size: 3em;
  line-height: 300px;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
section.module.parallax-1 {
  background-image: url("./assets/back1.jpg");
}
section.module.parallax-2 {
  background-image: url("./assets/back5.jpg");
}
section.module.parallax-3 {
  background-image: url("./assets/back3.jpg");
}
section.module.parallax-4 {
  background-image: url("./assets/back4.jpg");
}
section.module.parallax-5 {
  background-image: url("./assets/back6.jpg");
}
section.module.parallax-6 {
  background-image: url("./assets/back7.jpg");
}
section.module.parallax-titulo {
  background-image: url("./assets/back2.jpg");
}
@media (min-width: 992px) {
  body {
    padding-top: 0;
    padding-left: 17rem;
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Saira Extra Condensed", serif;
  font-weight: 700;
  text-transform: uppercase;
  color: #0F375B;
}

h1 {
  font-size: 6rem;
  line-height: 5.5rem;
  color: #0F375B;
}

h2 {
  font-size: 3.5rem;
}

.subheading {
  text-transform: uppercase;
  font-weight: 500;
  font-family: "Saira Extra Condensed", serif;
  font-size: 1.35rem;
}

.list-social-icons a {
  color: #495057;
}

.list-social-icons a:hover {
  color: #0F375B;
}

.list-social-icons a .fa-lg {
  font-size: 1.75rem;
}

.list-icons {
  font-size: 3rem;
}

.list-icons .list-inline-item i:hover {
  color: #0F375B;
}

#sideNav .navbar-nav .nav-item .nav-link {
  font-weight: 600;
  text-transform: uppercase;
}

@media (min-width: 992px) {
  #sideNav {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 17rem;
    height: 100vh;
  }
  #sideNav .navbar-brand {
    display: flex;
    margin: auto auto 0;
    padding: 0.5rem;
  }
  #sideNav .navbar-brand .img-profile {
    max-width: 10rem;
    max-height: 10rem;
    border: 0.5rem solid rgba(255, 255, 255, 0.2);
  }
  #sideNav .navbar-collapse {
    display: flex;
    align-items: flex-start;
    flex-grow: 0;
    width: 100%;
    margin-bottom: auto;
  }
  #sideNav .navbar-collapse .navbar-nav {
    flex-direction: column;
    width: 100%;
  }
  #sideNav .navbar-collapse .navbar-nav .nav-item {
    display: block;
  }
  #sideNav .navbar-collapse .navbar-nav .nav-item .nav-link {
    display: block;
  }
}
section.resume-section {
  border-bottom: 1px solid #dee2e6;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}
section.resume-section .resume-item .resume-date {
  min-width: none;
}
@media (min-width: 768px) {
  section.resume-section {
    min-height: 100vh;
  }
  section.resume-section .resume-item .resume-date {
    min-width: 18rem;
  }
}
@media (min-width: 992px) {
  section.resume-section {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}
.text-primary {
  color: #0F375B !important;
}

a {
  color: #367fbf;
}
a:hover,
a:focus,
a:active {
  color: #89af3f !important;
}
.borde {
  -moz-background-clip: border; /* Firefox 3.6 */
  -webkit-background-clip: border; /* Safari 4? Chrome 6? */
  background-clip: border-box; /* Firefox 4, Safari 5, Opera 10, IE 9 */

  -moz-background-clip: padding; /* Firefox 3.6 */
  -webkit-background-clip: padding; /* Safari 4? Chrome 6? */
  background-clip: padding-box; /* Firefox 4, Safari 5, Opera 10, IE 9 */

  -moz-background-clip: content; /* Firefox 3.6 */
  -webkit-background-clip: content; /* Safari 4? Chrome 6? */
  background-clip: content-box; /* Firefox 4, Safari 5, Opera 10, IE 9 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue